<template>


    <div>
        <h3 class="subtitle is-3  has-text-grey">Search Item for Mapping with Pathogen Data</h3>
        <ListParts :placeholderTxt="placeholderTxt" @addItemToDetail="addItemToDetail"/>
    </div>
<!--    <div class="modal is-active" v-on:keyup.en<ter.prevent="enterKeyPress"  v-on:keyup.esc="closeBtn" >-->
<!--        <div class="modal-background"></div>-->
<!--        <div class="modal-card">-->
<!--            <header class="modal-card-head">-->
<!--                <p class="modal-card-title "   ></p>-->

<!--                <button class="delete" aria-label="close" @click="closeBtn"></button>-->
<!--            </header>-->
<!--            <section class="modal-card-body">-->
<!--                     <ListParts @addItemToDetail="selectItem"/>-->
<!--            </section>-->
<!--            <footer class="modal-card-foot">-->


<!--                <button class="button" @click="closeBtn">Cancel</button>-->
<!--            </footer>-->
<!--        </div>-->
<!--    </div>-->
</template>

<script>
    import ListParts from "../ListParts";
    export default {
        name: "SearchPartForMapIntoPathogen",
        components:{
            ListParts
        },
        props:{
            placeholderTxt : String
        },
        methods:{

            addItemToDetail(payload){
                this.$emit('closeSearchPartForMapIntoPathogen',payload)
                // console.log(JSON.stringify(payload))
            },

        }
    }
</script>

<style scoped>

</style>